import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2IssueStatus } from '@/api/model/interfaces';

export default class PackageKS2IssueStatusOdata extends OdataManager<PackageKS2IssueStatus> {}
